module.exports = __webpack_public_path__ + "3bb18594773a0df250b88e09eec49ad0.svg";